import React, { Fragment } from "react";
import moment from "moment";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import { alertAppointment } from "../../functions/Twilio";
import { getDayStr } from "../../functions/index";
import LiveChat from "../LiveChat";
import ManifestModal from "../Users/ManifestModal";
import RequestItem from "../../components/RequestItem";
import TicketDetailModal from "../../components/TicketDetailModal";
import AddNoteModal from "../../components/AddNoteModal";
import PDFViewerModal from "../../components/PDFViewer";
import SelectUserModal from "./SelectUserModal";
import ScheduleModal from "../CalendarHub/ScheduleModal";
import chat_png from "../../assets/media/chat.png";
import write_png from "../../assets/media/chatsuite/write.png";
import eco_chat_svg from "../../assets/media/ecochat.png";
import user_avatar from "../../assets/media/user.png";
import { CurrencyOptions } from "../../Constants/retailer";
import "./index.css";
import HexHover from "../../components/HexHover";
class ChatSuite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brandData: null,
      request_arr: [],
      selected: false,
      selected_user: null,
      request: "",
      chatdiv_visible: false,
      request_status: [],
      room_id: "",
      users: [],
      loading: false,
      brand_tasks: [],
      comingtask: false,
      ticketTypes: [],
      ticketIssues: [],
      fullUserUpgrade: false,
      selectedPDF: null,
    };
    this.manifestModalRef = React.createRef();
  }
  async componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      const sectors = await Firebase.getAllSectors();
      Firebase.getBrandDataByID(brand, (brand_data) => {
        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          categories: brand_data.userCategories || [],
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          hex: brand_data.hex,
          loading: true,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
          brandData: brand_data,
        });
        Firebase.getAllUsers(brand_data.name, this.subscribeUsers);
        Firebase.getAllTasksRunningByBrand(
          brand_data.name,
          this.subscribeTasks
        );
        const { sector } = brand_data;
        if (sector) {
          const sectorData = sectors[sector];
          const { ticket_types } = sectorData;
          if (ticket_types) this.setState({ ticketTypes: ticket_types });
        }
      });
      Firebase.getAllTicketIssues((ticketIssues) => {
        this.setState({ ticketIssues });
      });
      Firebase.getTicketByBrandID(brand, (res) => {
        if (res) {
          let flag = 0;
          Object.values(res).map((item) => {
            if (!item.tickets) flag = 1;
          });
          if (!flag) {
            const request_arr = Object.values(res);
            request_arr.forEach((item) => {
              let tickets = Object.values(item.tickets);
              const { username, uid, brand } = item;
              tickets
                .filter((item) => item.time)
                .forEach((item) => {
                  item.username = username;
                  item.uid = uid;
                  item.brand = brand;
                });
              item.tickets = tickets;
            });
            this.setState({ request_arr });
          }
        } else {
          this.setState({ selected: false, selected_tickets: null });
        }
      });
    }
  }
  // TODO: refactor this to only fetch one user's brand and eco data
  subscribeUsers = (users) => {
    const { selected_user } = this.state;
    let full_users = users.map(async (user) => {
      const { eco_id } = user;
      let eco_data = {};
      if (eco_id) eco_data = await Firebase.getEcoUserbyId(eco_id);
      return { ...user, ...eco_data };
    });
    Promise.all(full_users).then((res) => {
      this.setState({ users: res, loading: false });
      if (selected_user) {
        const newSelectedUser = res.find(
          (user) => user.id === selected_user.id
        );
        this.setState({ selected_user: newSelectedUser });
      }
    });
  };
  subscribeTasks = (tasks) => {
    this.setState({ brand_tasks: tasks });
  };
  getStatus = (status) => {
    if (status === "waiting") return "waiting";
    if (status === "ok") return "connected";
    if (status === "false") return "disconnected";
  };
  clickRequest = async (item, index) => {
    const { users } = this.state;
    const { tickets } = item;
    let full_user = users.find((user) => user.id === item.uid);
    let { request_status } = this.state;
    this.setState({ request: item, fullUserUpgrade: false });
    this.setState({ selected_tickets: Object.values(tickets) });
    this.setState({ clicked: index });
    this.setState({ selected_user: full_user });
    this.setState({ userIcon: full_user.avatar_url });
    const value = request_status[index];
    request_status = request_status.map((item, i) => {
      return false;
    });
    request_status[index] = !value;
    this.setState({ request_status, ticket: false, chatdiv_visible: false });
  };
  clickTicketDetail = (ticket, item, index) => {
    this.setState({ ticket: ticket });
    this.setState({ ticket_opened: index });
    this.setState({ membername: item.username });
  };
  clickTicket = (ticket, item, index) => {
    const { uid, username } = item;
    let { brand_tasks } = this.state;
    let user_tasks = brand_tasks.filter((task) => task.options.user.id === uid);
    const { ticket_id, requestFullUpgrade } = ticket;
    let task = null;
    if (user_tasks.length > 0)
      task = user_tasks.find(
        (task) =>
          task.options.ticket && task.options.ticket.ticket_id === ticket_id
      );
    this.setState({
      ticket: ticket,
      ticket_opened: index,
      chatdiv_visible: true,
      room_id: uid,
      membername: username,
      comingtask: task,
      requestFullUpgrade: requestFullUpgrade,
    });
  };
  getLatestTimeofTickets = (tickets) => {
    let latest_time = 0;
    tickets.map((ticket) => {
      let content = ticket.content;
      let latest_message_time = 0;
      if (content) {
        latest_message_time = Object.values(content)[0].time;
        Object.values(content).map((message) => {
          if (latest_message_time < message.time)
            latest_message_time = message.time;
        });
      } else latest_message_time = ticket.time;
      if (latest_time < latest_message_time) latest_time = latest_message_time;
    });
    return latest_time;
  };
  showRequest = () => {
    const { clicked, ticket_opened, request_status, users, brandData } =
      this.state;
    let { request_arr } = this.state;
    //show only existing users' tickets
    let userid_list = users.map((user) => user.id);
    request_arr = request_arr.filter((user) => userid_list.includes(user.uid));
    request_arr.sort((a, b) => {
      let a_tickets = a.tickets;
      let b_tickets = b.tickets;
      let a_time = this.getLatestTimeofTickets(a_tickets);
      let b_time = this.getLatestTimeofTickets(b_tickets);
      if (a_time < b_time) return 1;
      else return -1;
    });
    return request_arr.map((item, index) => {
      let full_user = users.find((user) => user.id === item.uid);
      // item.avatar_url = full_user.avatar_url || null;
      const userData = { ...item, ...full_user };
      return (
        <RequestItem
          key={index}
          brand={brandData}
          clickRequest={() => this.clickRequest(item, index)}
          data={userData}
          ticket_opened={ticket_opened === index ? true : false}
          clicked={clicked === index && request_status[index] ? true : false}
          clickDetail={(ticket) => this.clickTicketDetail(ticket, item, index)}
          clickTicket={(ticket) => this.clickTicket(ticket, item, index)}
        />
      );
    });
  };
  showTickets = () => {
    const { selected_tickets } = this.state;
    return selected_tickets.map((item) => {
      return (
        <p>
          Ticket number&nbsp;:&nbsp;{item.ticket_id} &nbsp;&nbsp;&nbsp;Ticket
          issue&nbsp;:&nbsp;
          {item.issue}
        </p>
      );
    });
  };
  goBack = () => this.props.history.goBack();

  goAgency = () => {
    let brand = this.props.location.state.brand;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    this.props.history.push("/agency", {
      brand: brand,
      username: username,
      role: role,
    });
  };
  onOpenChat = async (user) => {
    const { brand_name } = this.state;
    const { id: uid, firstname } = user.value;
    let ticket = {};
    let time = new Date().getTime().toString();
    ticket.time = time;
    ticket.title = "EcoChat";
    ticket.type = "EcoChat";
    ticket.issue = "EcoChat";
    ticket.id = Math.floor(10000000000 + Math.random() * 90000000000);
    ticket.ticket_id = ticket.id;
    ticket.status = "Open";
    await Firebase.createTicket(uid, firstname, brand_name, ticket);
    this.clickTicket(ticket, { uid, username: firstname }, 1);
  };
  schedule = async (option) => {
    const { selected_user: user, ticket } = this.state;
    const { brand_name: brand } = this.state;
    const { description, duration, time, title, date } = option;
    const { hh, mm } = time;
    const minutes = hh * 60 + mm;
    let m = moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    const scheduled_time = m.add(minutes, "minutes");

    let task = {
      brand,
      options: { user, title, description, duration, ticket },
      performAt: scheduled_time.toDate(),
      status: "scheduled",
      worker: "makeCall",
    };
    try {
      await Firebase.addTask(task);
      const { firstname, phonenumber } = user;
      if (phonenumber)
        alertAppointment(
          phonenumber,
          brand,
          firstname,
          getDayStr(scheduled_time.toDate())
        );
      this.addAppointment(scheduled_time.toDate().toString());
    } catch (error) {
      console.log("error", error);
    }
  };
  addAppointment = async (scheduled_time) => {
    let { room_id, ticket, username, membername, brand_name } = this.state;
    let time = new Date().getTime().toString();
    let { note } = await Firebase.getTicketDataOnce(room_id, ticket.ticket_id);
    let notes = note ? note : [];
    notes.push({
      time: time,
      note: `Hi ${membername}, I have created an appointment for us to meet through ${brand_name} chat at ${scheduled_time}.`,
      username: "Bot",
      noteType: "added-appointment",
      noter: username,
      noterId: localStorage.getItem("uid"),
    });
    Firebase.updateTicketNote(room_id, ticket.ticket_id, notes);
  };
  requestUserUpgrade = () => {
    let { room_id, ticket, brandData } = this.state;
    const { ticket_id } = ticket;
    this.setState({ ticket: { ...ticket, requestFullUpgrade: true } });
    this.addMessage({
      type: "bot",
      message: "May I verify your mobile to upgrade your access please?",
      username: "Bot",
    });
    setTimeout(() => {
      this.addMessage({
        type: "bot",
        username: "Bot",
        message: `You’ll receive 500 (${
          CurrencyOptions[brandData.territory || "UK"]
        }5) in reward tokens for upgrading.`,
      });
      Firebase.requestUserUpgrade(room_id, ticket_id);
      this.setState({ requestFullUpgrade: true });
    }, 1000);
  };
  addMessage = (message) => {
    let { room_id, ticket } = this.state;
    const { ticket_id } = ticket;
    message.time = Date.now();
    Firebase.addMessage(room_id, ticket_id, message, (res) => {
      if (ticket.status === "Waiting") {
        Firebase.acceptRequest(room_id, ticket_id);
      }
      Firebase.setUnReadMessage(room_id, ticket_id, {
        latest: message.message,
        time: message.time,
        ticket: ticket,
      });
    });
  };
  handleChangeProfile = async (name, value, isBrandProfile) => {
    const { selected_user, brand_name } = this.state;
    const { eco_id } = selected_user;
    if (!isBrandProfile) {
      if (eco_id) {
        await Firebase.updateEcoUser(eco_id, { [name]: value }); //if eco user then update eco data
      } else {
        await Firebase.updateUserData(brand_name, selected_user.id, {
          [name]: value,
        }); // update user data
      }
    } else if (isBrandProfile) {
      await Firebase.updateUserData(brand_name, selected_user.id, {
        [name]: value,
      });
    }
    // this.loadUser(brand_name);
  };
  handleSaveManifest = async (ecoChanges, brandChanges) => {
    const { selected_user, brand_name } = this.state;
    const { eco_id } = selected_user;
    if (JSON.stringify(ecoChanges) !== "{}" && eco_id) {
      console.log("save eco change", ecoChanges);
      await Firebase.updateEcoUser(eco_id, ecoChanges);
    }
    if (JSON.stringify(brandChanges) !== "{}") {
      console.log("save brand change", brandChanges);
      await Firebase.updateUserData(brand_name, selected_user.id, brandChanges);
    }
  };
  addTokens = async (payload) => {
    const { selected_user, brand_name, ticket } = this.state;
    if (!selected_user) return;
    const { premierTokens, shoppingTokens, category } = payload;
    const tokenNum = parseInt(shoppingTokens, 10);
    if (shoppingTokens) {
      await Firebase.saveTokenSpentHistory(brand_name, selected_user.id, {
        created: new Date(),
        amount: -tokenNum,
        type: category.label,
      });
      await Firebase.updateUserData(brand_name, selected_user.id, {
        tokens: (selected_user.tokens || 0) + tokenNum,
      });
      const message = {
        type: "shopping_token_bot",
        message: `I have assigned you ${tokenNum} shopping tokens for <b>${category.label}</b>.`,
      };
      message.time = Date.now();
      Firebase.addMessage(
        selected_user.id,
        ticket.ticket_id,
        message,
        (res) => {
          Firebase.setUnReadMessage(selected_user.id, ticket.ticket_id, {
            latest: message.message,
            time: message.time,
            ticket: ticket,
          });
        }
      );
    }
    if (premierTokens) {
      this.addPremierTokens(premierTokens);
      const message = {
        type: "premier_token_bot",
        message: `I have assigned you ${premierTokens} premier tokens for <b>${category.label}</b>`,
      };
      message.time = Date.now();
      Firebase.addMessage(
        selected_user.id,
        ticket.ticket_id,
        message,
        (res) => {
          Firebase.setUnReadMessage(selected_user.id, ticket.ticket_id, {
            latest: message.message,
            time: message.time,
            ticket: ticket,
          });
        }
      );
    }
  };
  addPremierTokens = async (amount) => {
    const { role, selected_user, brand_name } = this.state;
    await Firebase.savePremierTokenHistory(brand_name, selected_user.id, {
      created: new Date(),
      amount: -amount,
      type: "gift",
      environment: "production",
    });
    this.loadUser();
  };
  handleClickAttachment = (content) => {
    const { media_type, media_url } = content;
    if (media_type === "pdf_file") this.setState({ selectedPDF: media_url });
  };

  render() {
    const {
      logo,
      brand,
      is_property_brand,
      chatdiv_visible,
      room_id,
      ticket,
      membername,
      brand_name,
      icon,
      loading,
      userIcon,
      users,
      comingtask,
      brandData,
      ticketIssues,
      selected_user,
      categories,
      requestFullUpgrade,
      selectedPDF,
    } = this.state;
    const HexButton = HexHover("button", brandData ? brandData.hex : "white");
    const { username, role } = this.props.location.state;

    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <div className="second-header">
          <div className="col-md-7 col-lg-7 col-xl-7 heading_pane">
            <img src={eco_chat_svg} height="35" alt="eco_chat_svg" />
            <div className="btn-div">
              <p>New Chat</p>
              <button data-toggle="modal" data-target="#select_user_modal">
                <img src={write_png} width="30" height="30" alt="write_svg" />
              </button>
            </div>
            <p>Chat with users and solve their tickets.</p>
          </div>

          <div className="col-md-5 col-lg-5 col-xl-5 btn-pane">
            {selected_user && (
              <Fragment>
                <div
                  className="avatar"
                  data-toggle="modal"
                  data-target="#manifest_modal"
                  style={{
                    backgroundImage: `url(${
                      selected_user.avatar_url || user_avatar
                    })`,
                  }}
                />
                <p>{selected_user.firstname}</p>
                {ticket && (
                  <Fragment>
                    {!selected_user.phonenumber &&
                      (requestFullUpgrade ? (
                        <p
                          className="color-orange"
                          style={{
                            fontSize: 15,
                            marginLeft: 10,
                            fontWeight: "800",
                          }}
                        >
                          Pending user upgrade
                        </p>
                      ) : (
                        <button
                          className="btn btn-red ml-5"
                          onClick={this.requestUserUpgrade}
                        >
                          Request full user upgrade
                        </button>
                      ))}
                    <HexButton
                      className="btn btn-light text-dark"
                      data-toggle="modal"
                      data-target="#add_note_dialog"
                      style={{ marginLeft: "auto" }}
                    >
                      Add note
                    </HexButton>
                  </Fragment>
                )}
              </Fragment>
            )}
          </div>
        </div>
        <div
          className="row no-gutters flex-md-10-auto"
          style={{ position: "fixed", width: "100%", height: "100%", top: 127 }}
        >
          <div
            className="col-md-7 col-lg-7 col-xl-7 bg-body-dark tickets-container"
            style={{ padding: 15, height: "90%", overflow: "auto" }}
          >
            <div className="content content-full">
              {loading ? (
                <div className="loading-spinner">
                  <i className="fa fa-4x fa-sync fa-spin text-muted" />
                  <p>Fetching tickets...</p>
                </div>
              ) : (
                <div className="block block-fx-pop">{this.showRequest()}</div>
              )}
            </div>
          </div>
          <div className="col-md-5 col-lg-5 col-xl-5" style={{ height: "87%" }}>
            {chatdiv_visible && (
              <LiveChat
                brand={brand_name}
                territory={brandData.territory}
                room_id={room_id}
                username={username}
                ticket={ticket}
                icon={icon}
                userIcon={userIcon}
                comingtask={comingtask}
              />
            )}
            {!chatdiv_visible && (
              <div className="empty_chat">
                <img src={chat_png} />
                <p>Select a chat ticket or start</p>
                <p>a new chat, to engage with</p>
                <p>your community members.</p>
              </div>
            )}
          </div>
        </div>
        {brandData && ticket && (
          <TicketDetailModal
            brandData={brandData}
            ticketId={ticket.ticket_id}
            roomId={room_id}
            userIcon={userIcon}
            membername={membername}
            ticketIssues={ticketIssues}
            uid={localStorage.getItem("uid")}
            username={username}
            onClickAttachment={this.handleClickAttachment}
          />
        )}
        <AddNoteModal
          brandData={brandData}
          roomId={room_id}
          uid={localStorage.getItem("uid")}
          ticket={ticket}
          username={username}
          onChangeProfile={this.handleChangeProfile}
          addTokens={this.addTokens}
        />
        <PDFViewerModal pdfUrl={selectedPDF} />
        {selected_user && (
          <ManifestModal
            user={selected_user}
            brandData={brandData}
            categories={categories}
            onChangeProfile={this.handleSaveManifest}
            onClickTicket={(ticket) => this.setState({ ticket: ticket })}
            onClickAttachment={this.handleClickAttachment}
            ref={this.manifestModalRef}
          />
        )}
        <SelectUserModal users={users} onOpenChat={this.onOpenChat} />
        <ScheduleModal
          users={false}
          isDatePickable={true}
          schedule={this.schedule}
        />
      </div>
    );
  }
}
export default ChatSuite;



// WEBPACK FOOTER //
// ./src/screens/ChatSuite/index.js